// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b68334da","952":"bec247ac"}[chunkId] + ".chunk.js";
};